import React from 'react';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

const ArrowIcon = () => {
  return (
    <ArrowDownwardIcon
      sx={{
        fontSize: {
          xs: '3.5rem',
          sm: '4rem',
          md: '6rem',
          lg: '6.5rem',
          xl: '7rem',
        },
      }}
    />
  );
};

export default ArrowIcon;
